import React from "react";
import styles from '../../styles/onlineCounselling.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
interface Props {
    whykcdata: any;
}

const WhyOnlineCounselling: React.FC<Props> = ({ whykcdata }) => {
    return (
        <div id="why-onlineCounselling" className={styles.WhyKc} style={{ backgroundColor: whykcdata?.sectionBgColor || "#fff" }}>
            <Container>
                <Row>
                    <div className="text-center">
                        <h2>{whykcdata.sectionTitle}</h2>
                    </div>
                </Row>
                <Row>
                    {
                        whykcdata?.whyKc?.length > 0 &&
                        whykcdata?.whyKc?.map((whydata: any) => {
                            return (
                                <Col xl={4} md={4} xs={12}>
                                    <div className="text-center mb-3">
                                        <div className={styles.img}>
                                            <CustomImage src={whydata?.imagePath || "/images/locationicon.png"} alt="whykc-icon-2.svg" width={105} height={77} />
                                        </div>
                                        <h6>{whydata?.title}</h6>
                                        <p>{whydata?.description}</p>
                                    </div>
                                </Col>
                            )
                        })
                    }

                </Row>
            </Container>
        </div>
    )
}
export default WhyOnlineCounselling;